var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_8453_23630)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.199219,
    y: 0.800537,
    width: 14.4,
    height: 14.4,
    rx: 7.2,
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.85444 5.45489C4.62013 5.6892 4.62013 6.0691 4.85444 6.30342L6.55176 8.00073L4.85444 9.69805C4.62013 9.93236 4.62013 10.3123 4.85444 10.5466C5.08875 10.7809 5.46865 10.7809 5.70297 10.5466L7.40029 8.84926L9.09708 10.5461C9.33139 10.7804 9.71129 10.7804 9.94561 10.5461C10.1799 10.3117 10.1799 9.93184 9.94561 9.69753L8.24881 8.00073L9.94561 6.30394C10.1799 6.06962 10.1799 5.68972 9.94561 5.45541C9.71129 5.2211 9.33139 5.2211 9.09708 5.45541L7.40029 7.1522L5.70297 5.45489C5.46865 5.22057 5.08875 5.22057 4.85444 5.45489Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_8453_23630",
    x: -47.8008,
    y: -47.1995,
    width: 110.4,
    height: 110.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8453_23630"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8453_23630",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.aa71bee19b1dd1cdf19d99aa3f6699fa.svg";
export { ForwardRef as ReactComponent };